import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import api from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

type ResetPasswordDTO = {
  userId: string;
  password: string;
  password_confirmation: string;
};


const resetPassword = async (data: ResetPasswordDTO) => {
  try {
    
    const payload = { password: data.password, password_confirmation: data.password_confirmation };

    const response = await api.patch(`/_exclusive/account/change-password/${data.userId}`, payload);

    return response.data;
  } catch (e) {
    if (e instanceof AxiosError) {
      const errorResponse = e.response?.data;

      if (errorResponse) {
        const message = errorResponse.message || 'Terjadi kesalahan saat mereset kata sandi.';
        
        if (errorResponse.errors?.password) {
          throw new Error(errorResponse.errors.password.join(', '));
        }
        throw new Error(message);
      }
    }
    throw new Error('Terjadi kesalahan yang tidak terduga.');
  }
};

export const useResetPassword = (config?: MutationConfig<typeof resetPassword>) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resetPassword,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['current-user'] });
    },
    ...config,
  });
};